import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getDessertFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does dessert food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: `What types of desserts do dessert food ${vehicleType}s offer?`,
    answer: `Ice cream, boba, churros, donuts, cupcakes, cookies, shaved ice, waffles, and pastries. Some ${vehicleType}s do seasonal flavors or a custom menu for the event; check each public profile for what it serves.`
  },
  {
    question: `Are dessert food ${vehicleType}s good for weddings and late-night snacks?`,
    answer: `Yes. Couples often book a dessert ${vehicleType} for after dinner or a late-night snack, in place of the cake or alongside it. Ask about a short service window if you only need an hour.`
  },
  {
    question: `Can dessert food ${vehicleType}s accommodate dietary needs like vegan or gluten-free?`,
    answer: `Many offer vegan, dairy-free, gluten-free, and nut-free options. Note dietary needs in your request so the ${vehicleType}s that quote can plan for them.`
  },
  {
    question: `How far in advance should I book a dessert food ${vehicleType} for my event?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  }
];

function DessertFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getDessertFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default DessertFaq;
